import React from 'react';
import Icon from '../../components/AppIcon';
import { useAdminAuth } from '../../context/AdminAuthContext';

export default function AdminSettingsPage() {
  const { profile, signOut } = useAdminAuth();

  return (
    <div className="space-y-6">
      <header className="flex flex-col gap-3 lg:flex-row lg:items-end lg:justify-between">
        <div>
          <h2 className="text-2xl font-semibold text-foreground">Admin Settings</h2>
          <p className="text-sm text-muted-foreground">Manage admin roles, escalation paths, and session policies.</p>
        </div>
        <button
          onClick={signOut}
          className="inline-flex items-center gap-2 rounded-md border border-border bg-card px-3 py-2 text-sm font-medium text-foreground shadow-sm hover:bg-muted"
        >
          <Icon name="LogOut" size={16} /> Sign out everywhere
        </button>
      </header>

      <div className="grid gap-6 lg:grid-cols-2">
        <section className="rounded-xl border border-border bg-card p-6 shadow-sm">
          <h3 className="text-lg font-semibold text-foreground">Your admin profile</h3>
          <p className="mt-1 text-sm text-muted-foreground">This information is pulled from Supabase admin_profiles.</p>
          <dl className="mt-4 space-y-3 text-sm">
            <div className="flex items-center justify-between rounded-md bg-muted/40 px-4 py-3">
              <dt className="font-medium text-muted-foreground">Full name</dt>
              <dd className="text-foreground">{profile?.full_name ?? 'Unknown'}</dd>
            </div>
            <div className="flex items-center justify-between rounded-md bg-muted/40 px-4 py-3">
              <dt className="font-medium text-muted-foreground">Email</dt>
              <dd className="text-foreground">{profile?.email ?? '—'}</dd>
            </div>
            <div className="flex items-center justify-between rounded-md bg-muted/40 px-4 py-3">
              <dt className="font-medium text-muted-foreground">Role</dt>
              <dd className="text-foreground capitalize">{profile?.role ?? 'admin'}</dd>
            </div>
            <div className="flex items-center justify-between rounded-md bg-muted/40 px-4 py-3">
              <dt className="font-medium text-muted-foreground">User ID</dt>
              <dd className="text-foreground">{profile?.user_id?.slice(0, 12) ?? '—'}…</dd>
            </div>
          </dl>
        </section>

        <section className="rounded-xl border border-border bg-card p-6 shadow-sm">
          <h3 className="text-lg font-semibold text-foreground">Session controls</h3>
          <p className="mt-1 text-sm text-muted-foreground">Adjust how long admin sessions stay active on shared devices.</p>
          <div className="mt-5 space-y-4 text-sm">
            <label className="flex flex-col gap-1">
              <span className="font-medium text-foreground">Idle timeout</span>
              <select className="rounded-md border border-border bg-background px-3 py-2 text-sm text-foreground shadow-sm">
                <option value="15m">15 minutes</option>
                <option value="30m">30 minutes</option>
                <option value="1h">1 hour</option>
                <option value="4h">4 hours</option>
              </select>
            </label>
            <label className="flex items-center gap-2">
              <input type="checkbox" defaultChecked className="h-4 w-4 rounded border border-border" />
              <span>Require OTP step-up for payouts or manual escrow releases</span>
            </label>
            <label className="flex items-center gap-2">
              <input type="checkbox" defaultChecked className="h-4 w-4 rounded border border-border" />
              <span>Notify security when a new admin joins</span>
            </label>
          </div>
          <div className="mt-6 flex justify-end">
            <button className="inline-flex items-center gap-2 rounded-md bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground shadow-sm hover:bg-primary/90">
              <Icon name="Save" size={16} /> Save preferences
            </button>
          </div>
        </section>
      </div>
    </div>
  );
}
